import BackgroundVideoProps from "../BackgroundVideoProps.interface";

import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default (props: BackgroundVideoProps): any => {
    const settings = useSelector(state => state.settings.content);
    const elementRef = useRef<any>(null);

    useEffect(() => {
        if (elementRef.current && settings) {
            if (props.content.showOverlay) {
                elementRef.current.style.setProperty("--overlay-background-color", settings.theme?.overlayBackgroundColor);

                if (props.content.overlayOverrule) {
                    elementRef.current.style.setProperty("--overlay-opacity", props.content.overlayOpacity);
                }
                else {
                    elementRef.current.style.setProperty("--overlay-opacity", settings.theme?.overlayOpacity);
                }
            }
        }
    }, [elementRef, settings]);

    return elementRef;
};